/* A local lifecycle keeps reassurance functional after cart section replacement. */
if (!customElements.get('jaiio-reassurance')) {
  class JaiioReassurance extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;

      this._track = this.querySelector('.jr-track');
      this._previous = this.querySelector('[data-jr-previous]');
      this._next = this.querySelector('[data-jr-next]');
      if (!this._track || !this._previous || !this._next) return;

      this._controller = new AbortController();
      const { signal } = this._controller;
      this._track.addEventListener('scroll', () => this._scheduleUpdate(), { passive: true, signal });
      this._track.addEventListener('keydown', event => this._onKeyDown(event), { signal });
      this._previous.addEventListener('click', () => this._move(-1), { signal });
      this._next.addEventListener('click', () => this._move(1), { signal });

      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver(() => this._scheduleUpdate());
        this._resizeObserver.observe(this._track);
      } else {
        window.addEventListener('resize', () => this._scheduleUpdate(), { passive: true, signal });
      }

      this._updateNavigation();
    }

    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._resizeObserver?.disconnect();
      this._resizeObserver = null;
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = null;
    }

    _scheduleUpdate() {
      if (this._frame) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = null;
        this._updateNavigation();
      });
    }

    _updateNavigation() {
      const end = Math.max(0, this._track.scrollWidth - this._track.clientWidth);
      const hasOverflow = end > 1;
      this._previous.hidden = !hasOverflow;
      this._next.hidden = !hasOverflow;
      this._previous.disabled = this._track.scrollLeft <= 1;
      this._next.disabled = this._track.scrollLeft >= end - 1;
    }

    _behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    _move(direction) {
      const items = this._track.children;
      const step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : this._track.clientWidth;
      this._track.scrollBy({ left: direction * step, behavior: this._behavior() });
    }

    _onKeyDown(event) {
      if (event.target !== this._track || event.altKey || event.ctrlKey || event.metaKey) return;

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          this._move(-1);
          break;
        case 'ArrowRight':
          event.preventDefault();
          this._move(1);
          break;
        case 'Home':
          event.preventDefault();
          this._track.scrollTo({ left: 0, behavior: this._behavior() });
          break;
        case 'End':
          event.preventDefault();
          this._track.scrollTo({ left: this._track.scrollWidth - this._track.clientWidth, behavior: this._behavior() });
          break;
      }
    }
  }

  customElements.define('jaiio-reassurance', JaiioReassurance);
}
